module.exports = __webpack_public_path__ + "img/hcp-partners-bgt.6f194ead.svg";